"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergeKeyStore = void 0;
var keystores_1 = require("@near-js/keystores");
Object.defineProperty(exports, "MergeKeyStore", { enumerable: true, get: function () { return keystores_1.MergeKeyStore; } });
